/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAssociationResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Association by ID send device token for authorisation
 */
export const getBmAccountingLocationV1AssociationAssociatingLocationTypeId = (
  associatingLocationType: 'counter' | 'cashDrawer',
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<GetAssociationResponseResponse>({
    url: `/bm-accounting-location/v1/association/${associatingLocationType}/${id}`,
    method: 'get',
    signal,
  });
};

export const getGetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryKey = (
  associatingLocationType: 'counter' | 'cashDrawer',
  id: string,
) => {
  return [`/bm-accounting-location/v1/association/${associatingLocationType}/${id}`] as const;
};

export const getGetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  associatingLocationType: 'counter' | 'cashDrawer',
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryKey(
      associatingLocationType,
      id,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>
  > = ({ signal }) =>
    getBmAccountingLocationV1AssociationAssociatingLocationTypeId(
      associatingLocationType,
      id,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(associatingLocationType && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>
>;
export type GetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Get Association by ID send device token for authorisation
 */
export const useGetBmAccountingLocationV1AssociationAssociatingLocationTypeId = <
  TData = Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  associatingLocationType: 'counter' | 'cashDrawer',
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationAssociatingLocationTypeId>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBmAccountingLocationV1AssociationAssociatingLocationTypeIdQueryOptions(
    associatingLocationType,
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
